import script from "./UpdateUser.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateUser.vue?vue&type=script&setup=true&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=18c4465f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c4465f"]])

export default __exports__